import { render, staticRenderFns } from "./VocabulariesList.vue?vue&type=template&id=07b499ad&scoped=true"
import script from "./VocabulariesList.vue?vue&type=script&lang=js"
export * from "./VocabulariesList.vue?vue&type=script&lang=js"
import style0 from "./VocabulariesList.vue?vue&type=style&index=0&id=07b499ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b499ad",
  null
  
)

export default component.exports